export class AppRoutes {
  static readonly home = "/";
  static readonly aboutus = "/about";
  static readonly contactus = "/contact";
  static readonly gallery = "/gallery";
}
